import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "./commonLanguageHeader";

export type RouteMode = "MANAGED_BY_IGNITION" | "MANAGED_BY_SERVER";
export type StartStopCriteria = "IGNITION" | "ONLY_CRITERIA";
export type DetectionBasedOn = "SPEED" | "GPS_COORDS";

export interface RouteSettingRecord {
  id?: string | number;
  vehicleId?: string | number;
  routeMode?: RouteMode;
  startStopCriteria?: StartStopCriteria;
  detectionBasedOn?: DetectionBasedOn;
  minSpeedKmh?: number | string | null;
  maxSpeedKmh?: number | string | null;
  geofenceMeters?: number | string | null;
  validationPoints?: number | string | null;
  idleTimeoutSec?: number | string | null;
  noDataTimeoutSec?: number | string | null;
  timeoutNoData?: number | string | null;
  stoppedTimeoutSec?: number | string | null;
}

export interface RouteSettingPayload extends RouteSettingRecord {
  vehicleId: string | number;
}

const ROUTE_SETTINGS_BY_VEHICLE_URL = "/ila/api/v1/route-settings/vehicle";
const ROUTE_SETTINGS_SAVE_URL = "/ila/api/v1/route-settings";

export const getRouteSettingByVehicleId = (vehicleId: string | number, language?: string) =>
  ApiService.get<{ response: RouteSettingRecord | RouteSettingRecord[] | null }>(
    `${ROUTE_SETTINGS_BY_VEHICLE_URL}/${vehicleId}`,
    getLanguageHeaders(language)
  );

export const saveRouteSettingByVehicleId = (payload: RouteSettingPayload, language?: string) =>
  ApiService.post(ROUTE_SETTINGS_SAVE_URL, payload, getLanguageHeaders(language));
